// extracted by mini-css-extract-plugin
export default {"disscussionMap":"DiscussionMap_disscussionMap__26g+m"};